import { LinkField } from "@sitecore-jss/sitecore-jss-nextjs";

import clsx from "clsx";
import React from "react";
import classes from "./animated-cta-link.module.css";

export interface AnimatedCtaLinkProps {
  link: LinkField;
  className?: string;
  style?: React.CSSProperties;
  textColor?: string;
}

const AnimatedCtaLink = ({
  className,
  link,
  style,
  textColor,
}: AnimatedCtaLinkProps) => {
  if (!link?.value?.href) return null;

  return (
    <a
      className={clsx(className, classes.animatedLink)}
      href={link.value.href as string}
      style={{ ...style, ...(textColor ? { color: textColor } : {}) }}
      target={typeof link.value.target === "string" ? link.value.target : ""}
      rel={typeof link.value.rel === "string" ? link.value.rel : undefined}
    >
      <span>{link.value.text}</span>
      <span className={classes.underline} />
    </a>
  );
};

export default AnimatedCtaLink;
